<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>Candidatos atuais</h4>
        </div>
        <div>
          <div class="form-inline">
            <div class="form-group mr-2">
              <range-date-filter
                :value="rangeDate"
                @input="(v) => { setFilters({stage_date: v}) }"
                style="min-width: 210px"> 
                </range-date-filter>
            </div>
            <button
              class="btn btn-light"
              @click="exportReport">
              {{ $t('Export xlsx') }}
              </button>
          </div>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">

      <filterfy
        :models="filtersMap"
        :initFilters="filters"
        @changed="setFilters">

        <Paginaty
          :total="grid.total"
          :pages="grid.pages"
          :page="grid.page"
          :creating="creating"
          :loading="loading"
          @changePage="setPage">
          
          <template slot="content">
            <table class="table table-bordered">
              <thead class="thead-fixed">
                <tr>
                  <th-sort
                    field="candidate.name"
                    :value="sort"
                    @input="setSort">{{ $t('Name') }}</th-sort>
                  <th-sort
                    field="candidate.email"
                    :value="sort"
                    @input="setSort">{{ $t('Email') }}</th-sort>
                  <th-sort
                    field="candidate.phones"
                    :value="sort"
                    @input="setSort">{{ $t('Phone') }}</th-sort>
                  <th-sort
                    field="job.title"
                    :value="sort"
                    @input="setSort">{{ $t('Job') }}</th-sort>
                  <th-sort
                    field="job.company.name"
                    :value="sort"
                    @input="setSort">{{ $t('Company') }}</th-sort>
                  <th-sort
                    field="job.departament.name"
                    :value="sort"
                    @input="setSort">{{ $t('Department') }}</th-sort>
                  <th-sort
                    field="stage.name"
                    :value="sort"
                    @input="setSort">{{ $t('Stage') }}</th-sort>
                  <th-sort
                    field="stage_date"
                    :value="sort"
                    @input="setSort">Data da movimentação</th-sort>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in grid.docs">
                  <td class="text-truncate">
                    <router-link
                      v-if="item.candidate"
                      :to="candidateRoute(item.candidate._id, item.job._id)">
                      {{ item.candidate.name }}
                      </router-link>
                  </td>
                  <td class="text-truncate"><span v-if="item.candidate">{{ item.candidate.email }}</span></td>
                  <td class="text-truncate"><span v-if="item.candidate">{{ getPhones(item.candidate.phones) }}</span></td>
                  <td class="text-truncate"><router-link :to="{path: '/job/' + item.job._id }">{{ item.job.title }}</router-link> #{{ item.job.code }}</td>
                  <td class="text-truncate">{{ item.job.company.name }}</td>
                  <td class="text-truncate">{{ item.job.departament.name }}</td>
                  <td class="text-truncate">{{ item.stage.name }}</td>
                  <td class="text-truncate">{{ $d(new Date(item.stage_date), 'short') }}</td>
                </tr>
              </tbody>
            </table>
          </template>

          <template slot="noresults">
            {{ $t('There are no items') }}
          </template>

        </Paginaty>

      </filterfy>

    </div>

  </div>

</template>

<script>
import Filterfy from '@/components/Filterfy/Filterfy'
import ThSort from '@/components/Parts/ThSort'
import Paginaty from '@/components/Paginaty/Paginaty'
import RangeDateFilter from './RangeDateFilter'
import BlobDownload from '@/utils/BlobDownload'
import FilterfyToQuery from '@/utils/FilterfyToQuery'
import moment from 'moment'

export default {
  name: 'CurrentCandidate',
  components: {
    Filterfy,
    ThSort,
    Paginaty,
    RangeDateFilter
  },
  data () {
    return {
      creating: true,
      loading: true,
      filtersMap: [
        {
          'type': 'list',
          'label': this.$t('Stage'),
          'target': 'stage_id',
          'resource': 'stages'
        },
        {
          'type': 'list',
          'label': this.$t('Company'),
          'target': 'job.company_id',
          'resource': 'companies'
        },
        {
          'type': 'list',
          'label': this.$t('Department'),
          'target': 'job.departament_id',
          'resource': 'departaments'
        }
      ],
      grid: false
    }
  },
  computed: {
    filters () {
      return this.$route.query
    },
    sort () {
      return this.$route.query.sort || '-stage_date'
    },
    rangeDate () {
      const defaultDate = `d|${moment().subtract(30, 'days').toISOString()}|${moment().toISOString()}`
      return this.$route.query.stage_date === undefined ? defaultDate : this.$route.query.stage_date
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.loading = true

      const params = {
        ...FilterfyToQuery(this.filters, this.filtersMap),
        stage_date: this.rangeDate,
        page: this.$route.query.page || 1,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.axios
      .get('/accounts/' + this.$store.getters.getAccount._id + '/reports/current-candidate', {params: params})
      .then((response) => {
        this.grid = response.data
        this.loading = this.creating = false
      })
    },
    /*
    setFilters
    */
    setFilters (filters) {
      this.$changeUrlParam(filters)
      this.setPage(1)
    },
    setSort (sort) {
      this.$changeUrlParam({sort: sort})
      this.setPage(1)
    },
    setPage (page) {
      this.$changeUrlParam({page: page})
      this.loadData()
    },
    getPipelineStage (pipeline, id) {
      let stage = false
      pipeline.forEach((v) => {
        if (v.stage_id === id) stage = v
      })
      return stage
    },
    getPhones (phones) {
      return phones && typeof (phones) === 'object' ? phones.join(', ') : ''
    },
    exportReport () {
      const params = {
        ...this.filters,
        sort: this.sort
      }

      this.axios
      .get('/accounts/' + this.$store.getters.getAccount._id + '/reports/current-candidate/export', {params: params, responseType: 'blob', timeout: 30000})
      .then((response) => {
        BlobDownload(response)
      })
    },
    candidateRoute (candidateId, jobId) {
      return {
        query: {
          ...this.$clone(this.$route.query),
          candidate_id: candidateId,
          candidate_job_id: jobId
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Report/ReportCurrentCandidate.vue